import { endpoints } from '@source/config'

export const HOME_PLAYLIST_ENDPOINT = `${endpoints.api}/videos/cache/playlists`
export const HOME_PLAYLIST_ENDPOINT_NOCACHE = `${endpoints.api}/videos/playlists`
export const VIDEOS_ENDPOINT = `${endpoints.api}/videos/cache`
export const VIDEOS_ENDPOINT_NOCACHE = `${endpoints.api}/videos`
export const VIDEOS_CHECK_PERMISSION = `${endpoints.api}/videos/permission/check`
export const GEOGUARD_ENDPOINT = `${endpoints.api}/videos/geoguard/check`
export const CHECK_BANNED_ENDPOINT = `${endpoints.api}/sessions/check`
export const FINGERPRINT_ENDPOINT = `${endpoints.api}/sessions/fingerprint`

export const HISTORY_ENDPOINT = `${endpoints.api}/userdata`

export const SEARCH_ENDPOINT = `${endpoints.analytic}/v1/analytics/prophet/search/suggestions`
export const RECENT_SEARCH_ENDPOINT = `${endpoints.api}/search/histories`

export const SUBSCRIPTION_ENDPOINT = `${endpoints.api}/subscriptions/v2/subscriptions`
export const SUBSCRIPTIONS_ENDPOINT = `${endpoints.api}/subscriptions/subscriptions`
export const USER_SUBSCRIPTION = `${endpoints.api}/subscriptions/user-subscription`
export const USER_SUBSCRIPTIONS = `${endpoints.api}/subscriptions/user-subscriptions`
export const ORDER_ENDPOINT = `${endpoints.api}/orders`
export const HISTORY_ORDER_ENDPOINT = `${endpoints.api}/payments/api/v1/history/order`
export const PAYMENT_ENDPOINT = `${endpoints.api}/payments/api/v1/dopay/mola`
export const ANONYMOUS_PAYMENT_ENDPOINT = `${endpoints.api}/payments/api/v1/anonymous-payment`
export const PAYMENT_MCBILL_ENDPOINT = `${endpoints.api}/payments/api/v1/pay/mcbill`
export const PAYMENT_REFUND_ENDPOINT = `${endpoints.api}/payments/api/v1/refund`
export const PAYMENT_SUBSCRIPTION = `${endpoints.api}/payments/api/v1/subscription`
export const MAPPING_SUBSCRIPTION_ENDPOINT = `${endpoints.api}/payments/api/v1/mappings/subscription`
export const MAPPING_SUBSCRIPTION_CATEGORIZED_ENDPOINT = `${endpoints.api}/payments/api/v1/mappings/categorized/subscription`
export const METHOD_INSTRUCTIONS_ENDPOINT = `${endpoints.api}/payments/api/v1/instruction/paymentmethod`
export const CAMPAIGN_ENDPOINT = `${endpoints.api}/campaigns/banner-positions`
export const CAMPAIGN_POSITION_ENDPOINT = `${endpoints.api}/campaigns/position-playlists/playlist` //https://stag.mola.tv/api/v2/campaigns/position-playlists/playlist/pybanner?app_id=molatv
export const ADD_DEVICE_ENDPOINT = `${endpoints.api}/videos/drm/add-device`
// export const CHANNELS_PLAYLIST_ENDPOINT = `${endpoints.api}/videos/playlists`
// export const RECOMMENDATION = `${endpoints.api}/videos/recommendation`
// export const RECOMMENDATION = `${endpoints.api}/videos/recommendation`
export const RECOMMENDATION_USER = `${endpoints.analytic}/v1/analytics/prophet/recommendation/user`
export const RECOMMENDATION = `${endpoints.analytic}/v1/analytics/prophet/recommendation/videos`
export const RECOMMENDATION_TOP_PICKS = `${endpoints.analytic}/v1/analytics/prophet/recommendation/top-picks`
export const POPULAR = `${endpoints.analytic}/v1/analytics/prophet/recommendation/featured`

export const ARTICLES_ENDPOINT = `${endpoints.api}/articles/articles`
export const ARTICLES_RECOMMENDED_ENDPOINT = `${endpoints.api}/articles/lists`
export const ARTICLES_RELATED_ENDPOINT = `${endpoints.api}/articles/related`
export const PARTNERS_ENDPOINT = `${endpoints.api}/config/partners`
export const CUT_PRICE_PROMO_ENDPOINT = `${endpoints.api}/promos/validate/cut-price`
export const VALIDATE_PROMO_ENDPOINT = `${endpoints.api}/promos/voucher/validate`
export const SESSION_RESTRICTION_ENDPOINT = `${endpoints.api}/sessions/restriction/validate`

export const NOTIFICATION_ENDPOINT = `${endpoints.api}/inbox/notif`
export const PROFILE_ENDPOINT = `${endpoints.api}/accounts/profile`
export const SELECTED_ATTRIBUTES_ENDPOINT = `${endpoints.api}/videos/playlists/attributes`

export const PROMO_DETAIL_ENDPOINT = `${endpoints.api}/promos/voucher/type`

export const QUIZ_ENDPOINT = `${endpoints.api}/games/quiz/shows`

export const LANDINGPAGE_SUBSCRIBE_ENDPOINT = `${endpoints.api}/campaigns/banner-positions/landing-page-subscribe`
export const INBOX_ENDPOINT = `${endpoints.api}/inbox`
export const TEAM_ENDPOINT = `${endpoints.api}/videos/teams`
export const STATISTICS_STANDINGS_ENDPOINT = `${endpoints.api}/statistics/standings`

export const VIDEO_DIAGNOSTIC_ENDPOINT = `${endpoints.api}/videos/diagnostic`
export const MOLA_HUB_ENDPOINT = `${endpoints.api}/config/hub/p`
